import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import { ElLoading } from "element-plus";
import { markRaw } from "vue";

// 得森学生统计和学生Excel导出共用的排除名单（figures/1.png至5.png）。
const DESEN_STUDENT_EXCLUDED_TEACHERS = new Set(["英语测试", "AMC模考", "月考1-不计课时", "月考-不计课时", "物理模考", "数学模考", "英语模考", "英文数学模考", "督学03", "督学02", "督学01", "托福模考-不计课时", "雅思模考-不计课时", "数学模考-basis", "英语模考-basis", "数学模考-展华", "数学模考-国交A1", "数学模考-国交G1", "数学模考-FP2", "英语模考-展华", "数学模考-P4", "英语模考-国交"]);
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      dateRange: [],
      desenRows: [],
      statisticsBusy: false,
      statisticsLoadingText: "正在加载课时统计...",
      desenMountedViews: {
        class: true,
        teacher: false,
        student: false
      },
      desenStudentSearchStr: "",
      desenStudentSearchField: "studentName",
      desenScrollRow: 0,
      desenVirtualRowHeight: 48,
      desenVirtualBodyHeight: 554,
      desenVirtualBuffer: 4,
      desenTooltipVisible: false,
      desenTooltipTarget: null,
      desenTooltipText: "",
      showDesenExportDialog: false,
      exportDateRange: [],
      exportTargetId: "",
      exportingDesen: false,
      classCourseTeacherHour: {},
      oriClassCourseTeacherHour: {},
      classCourseTeacherArr: {},
      oriClassCourseTeacherArr: {},
      teacherClassCourseHour: {},
      oriTeacherClassCourseHour: {},
      teacherClassCourseArr: {},
      oriTeacherClassCourseArr: {},
      studentClassCourseHour: {},
      oriStudentClassCourseHour: {},
      studentClassCourseArr: {},
      oriStudentClassCourseArr: {},
      teacherHours: {},
      classHours: {},
      studentHours: {},
      teacherNames: {},
      classNames: {},
      classType: {},
      classCampusId: {},
      campusNames: {},
      studentNames: {},
      // 搜索
      searchStr: "",
      showSearchResult: false,
      totalHour: 0,
      searchPlaceholder: "",
      // 班级/老师/学生 切换
      showStatisticsType: "class",
      displayedStatisticsType: "class"
    };
  },
  computed: {
    desenClassRowCount() {
      return Object.values(this.classCourseTeacherHour).reduce((total, courses) => total + Object.values(courses).reduce((count, teachers) => count + Object.keys(teachers).length, 0), 0);
    },
    desenTeacherRowCount() {
      return Object.values(this.teacherClassCourseHour).reduce((total, classes) => total + Object.values(classes).reduce((count, courses) => count + Object.keys(courses).length, 0), 0);
    },
    desenStudentSearchLabel() {
      return {
        studentName: "学生",
        teacherName: "老师",
        className: "班级"
      }[this.desenStudentSearchField] || "学生";
    },
    preparedDesenRows() {
      return this.prepareDesenStudentRows(this.desenRows, this.desenStudentSearchStr, this.desenStudentSearchField);
    },
    desenVirtualRange() {
      const count = this.preparedDesenRows.length;
      const first = Math.min(this.desenScrollRow, Math.max(0, count - 1));
      return {
        start: Math.max(0, first - this.desenVirtualBuffer),
        end: Math.min(count, first + Math.ceil(this.desenVirtualBodyHeight / this.desenVirtualRowHeight) + this.desenVirtualBuffer)
      };
    },
    desenVisibleRows() {
      const {
        start,
        end
      } = this.desenVirtualRange;
      return this.preparedDesenRows.slice(start, end);
    },
    desenVirtualStyle() {
      const {
        start,
        end
      } = this.desenVirtualRange;
      return {
        "--desen-virtual-top": `${start * this.desenVirtualRowHeight}px`,
        "--desen-virtual-bottom": `${(this.preparedDesenRows.length - end) * this.desenVirtualRowHeight}px`
      };
    },
    desenTotalHour() {
      const totalMinutes = this.preparedDesenRows.reduce((sum, row) => {
        const name = String(row.studentName || "").trim();
        if (!row.studentId || !name || name === "-") return sum;
        return sum + (row.totalMinutes == null ? (Number(row.hour) || 0) * 60 : Number(row.totalMinutes));
      }, 0);
      return parseFloat((totalMinutes / 60).toFixed(2));
    },
    desenHoursByClassType() {
      const minutes = {
        oneToOne: 0,
        group: 0,
        other: 0
      };
      const otherMinutes = new Map();
      let hasOther = false;
      for (const row of this.preparedDesenRows) {
        const name = String(row.studentName || "").trim();
        if (!row.studentId || !name || name === "-") continue;
        const type = String(row.classType || "").trim();
        const category = type === "一对一" ? "oneToOne" : type === "班课" ? "group" : "other";
        const duration = row.totalMinutes == null ? (Number(row.hour) || 0) * 60 : Number(row.totalMinutes);
        if (category === "other") {
          hasOther = true;
          const typeName = type || "-";
          otherMinutes.set(typeName, (otherMinutes.get(typeName) || 0) + duration);
        }
        minutes[category] += duration;
      }
      return {
        oneToOne: parseFloat((minutes.oneToOne / 60).toFixed(2)),
        group: parseFloat((minutes.group / 60).toFixed(2)),
        other: parseFloat((minutes.other / 60).toFixed(2)),
        hasOther,
        otherDetails: Array.from(otherMinutes, ([type, total]) => ({
          type,
          hour: parseFloat((total / 60).toFixed(2))
        })).sort((a, b) => a.type.localeCompare(b.type, "zh-CN"))
      };
    },
    desenExportTargetOptions() {
      const names = this.studentNames;
      return Object.entries(names).map(([id, name]) => ({
        id: String(id),
        name
      })).sort((a, b) => String(a.name).localeCompare(String(b.name), "zh-CN"));
    }
  },
  watch: {
    desenRows() {
      this.resetDesenVirtualScroll();
    },
    desenStudentSearchStr() {
      this.resetDesenVirtualScroll();
    },
    desenStudentSearchField() {
      if (this.institution === "得森" && this.showStatisticsType === "student") {
        this.searchPlaceholder = `搜索${this.desenStudentSearchLabel}`;
      }
      this.resetDesenVirtualScroll();
    }
  },
  async mounted() {
    this.getCurrentMonthRange();
    this.searchPlaceholder = "搜索班级";

    // 获取课时统计
    this.getClassCourseTeacherHour();
  },
  methods: {
    // 获取当前月第一天和最后一天
    getCurrentMonthRange() {
      const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
      const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
      this.dateRange = [startOfMonth, endOfMonth];
    },
    // 获取课时统计
    async getClassCourseTeacherHour() {
      if (this.institution === "得森" && this.statisticsBusy) return;
      if (this.institution === "得森") this.hideDesenCellTooltip();
      this.statisticsLoadingText = "正在加载课时统计...";
      this.statisticsBusy = true;
      //loading界面
      // 得森由常驻独立提示层控制，避免共享全屏实例和加载组件的过渡检测。
      const loading = this.institution === "得森" ? null : ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.institution === "得森") await this.waitForStatisticsPaint();
        let params = {
          dateRange: this.dateRange,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseStatistics/getClassCourseTeacherHour", params);
        if (resp1.data.code == "0000") {
          const responseData = resp1.data.data || {};
          const prepareData = value => this.institution === "得森" ? markRaw(value) : value;
          this.desenRows = prepareData(responseData.desenRows || []);
          // 班级课时
          this.classCourseTeacherHour = prepareData(responseData.classCourseTeacherHour || {});
          if (this.classCourseTeacherHour) {
            this.oriClassCourseTeacherHour = this.institution === "得森" ? this.classCourseTeacherHour : JSON.parse(JSON.stringify(this.classCourseTeacherHour));
          }
          this.classHours = {};
          // 计算每个班级的课时合计
          for (let classId in this.classCourseTeacherHour) {
            let classTotalHour = 0;
            for (let course in this.classCourseTeacherHour[classId]) {
              for (let teacherId in this.classCourseTeacherHour[classId][course]) {
                classTotalHour += this.classCourseTeacherHour[classId][course][teacherId].hour;
              }
            }
            this.classHours[classId] = classTotalHour;
          }

          // 老师课时
          this.teacherClassCourseHour = prepareData(responseData.teacherClassCourseHour || {});
          if (this.teacherClassCourseHour) {
            this.oriTeacherClassCourseHour = this.institution === "得森" ? this.teacherClassCourseHour : JSON.parse(JSON.stringify(this.teacherClassCourseHour));
          }
          this.teacherHours = {};
          // 计算每个老师合计课时
          for (let teacherId in this.teacherClassCourseHour) {
            let teacherTotalHour = 0;
            for (let classId in this.teacherClassCourseHour[teacherId]) {
              for (let course in this.teacherClassCourseHour[teacherId][classId]) {
                teacherTotalHour += this.teacherClassCourseHour[teacherId][classId][course].hour;
              }
            }
            this.teacherHours[teacherId] = teacherTotalHour;
          }

          // 学生课时
          this.studentClassCourseHour = responseData.studentClassCourseHour || {};
          if (this.studentClassCourseHour) {
            this.oriStudentClassCourseHour = JSON.parse(JSON.stringify(this.studentClassCourseHour));
          }
          this.studentHours = {};

          // 计算每个学生合计课时
          for (let studentId in this.studentClassCourseHour) {
            let studentTotalHour = 0;
            for (let classId in this.studentClassCourseHour[studentId]) {
              for (let course in this.studentClassCourseHour[studentId][classId]) {
                studentTotalHour += this.studentClassCourseHour[studentId][classId][course].hour;
              }
            }
            this.studentHours[studentId] = studentTotalHour;
          }
          this.classNames = responseData.classNames || {};
          this.classType = responseData.classType || {};
          this.classCampusId = responseData.classCampusId || {};
          this.campusNames = responseData.campusNames || {};
          this.teacherNames = responseData.teacherNames || {};
          this.studentNames = responseData.studentNames || {};

          // 班级 科目 老师 有哪些课
          this.classCourseTeacherArr = prepareData(responseData.classCourseTeacherArr || {});
          if (this.classCourseTeacherArr) {
            this.oriClassCourseTeacherArr = this.institution === "得森" ? this.classCourseTeacherArr : JSON.parse(JSON.stringify(this.classCourseTeacherArr));
          }

          // 老师 班级 科目 有哪些课
          this.teacherClassCourseArr = prepareData(responseData.teacherClassCourseArr || {});
          if (this.teacherClassCourseArr) {
            this.oriTeacherClassCourseArr = this.institution === "得森" ? this.teacherClassCourseArr : JSON.parse(JSON.stringify(this.teacherClassCourseArr));
          }

          // 学生 班级 科目 有哪些课
          this.studentClassCourseArr = responseData.studentClassCourseArr || {};
          if (this.studentClassCourseArr) {
            this.oriStudentClassCourseArr = JSON.parse(JSON.stringify(this.studentClassCourseArr));
          }

          // 统计课时
          this.search();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:" + error);
        alert("catch error: " + error);
      } finally {
        try {
          if (this.institution === "得森") await this.waitForStatisticsReady();
        } finally {
          this.statisticsBusy = false;
          if (loading) loading.close();
        }
      }
    },
    async waitForStatisticsReady() {
      await this.$nextTick();
      const table = this.$refs.desenTableRef;
      if (!table) {
        await this.waitForStatisticsPaint();
        return;
      }

      // 两帧仅保证一次绘制，不能保证表格的50ms防抖布局、ResizeObserver及后续更新结束。
      // 只执行已经排队的布局，不对缓存表格重复调用doLayout；更新后再等布局和DOM稳定。
      let changed = false;
      const onChange = () => {
        changed = true;
      };
      const mutations = typeof MutationObserver === "function" ? new MutationObserver(onChange) : null;
      const resizes = typeof ResizeObserver === "function" ? new ResizeObserver(onChange) : null;
      mutations?.observe(table.$el, {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true
      });
      resizes?.observe(table.$el);
      const body = table.$el.querySelector(".el-table__body-wrapper");
      if (body) resizes?.observe(body);
      try {
        let stablePaints = 0;
        while (stablePaints < 2 && this.$refs.desenTableRef === table) {
          changed = false;
          table.debouncedUpdateLayout?.flush?.();
          await this.waitForStatisticsPaint();
          stablePaints = changed ? 0 : stablePaints + 1;
        }
      } finally {
        mutations?.disconnect();
        resizes?.disconnect();
      }
    },
    async waitForStatisticsPaint() {
      await this.$nextTick();
      await new Promise(resolve => {
        if (document.hidden || typeof requestAnimationFrame !== "function") {
          setTimeout(resolve, 0);
        } else {
          // 留出完整绘制帧，保证先显示转圈，再开始可能阻塞主线程的表格更新。
          requestAnimationFrame(() => requestAnimationFrame(resolve));
        }
      });
    },
    dateRangeChange() {
      console.log("this.dateRange:", this.dateRange);
      this.getClassCourseTeacherHour();
    },
    desenRowKey(row) {
      return `${row.courseArrangeId}:${row.studentId || 0}`;
    },
    desenVirtualScroll({
      scrollTop
    }) {
      this.hideDesenCellTooltip();
      this.desenScrollRow = Math.floor(Math.max(0, scrollTop) / this.desenVirtualRowHeight);
    },
    showDesenCellTooltip(row, column, cell) {
      this.hideDesenCellTooltip();
      if (!["studentName", "className", "teacherName", "classType", "campusName", "course"].includes(column.property)) return;
      const content = cell.querySelector(".cell");
      // App使用CSS zoom：不能把未缩放的scrollWidth与缩放后的矩形宽度比较。
      if (!content || content.scrollWidth <= content.clientWidth) return;
      this.desenTooltipText = content.textContent.trim();
      this.desenTooltipTarget = markRaw(content);
      this.desenTooltipVisible = Boolean(this.desenTooltipText);
    },
    hideDesenCellTooltip() {
      this.desenTooltipVisible = false;
      this.desenTooltipTarget = null;
      this.desenTooltipText = "";
    },
    resetDesenVirtualScroll() {
      if (this.institution !== "得森") return;
      this.hideDesenCellTooltip();
      this.desenScrollRow = 0;
      this.$nextTick(() => this.$refs.desenTableRef?.setScrollTop(0));
    },
    prepareDesenStudentRows(sourceRows, searchStr = "", searchField = "studentName") {
      const keyword = searchStr.trim().toLowerCase();
      const field = ["studentName", "teacherName", "className"].includes(searchField) ? searchField : "studentName";
      const studentKey = row => String(row.studentId || `empty-${row.classId}`);
      const hasStudentName = row => Boolean(row.studentId && String(row.studentName || "").trim() && String(row.studentName).trim() !== "-");
      const rows = sourceRows.filter(row => this.institution !== "得森" || !DESEN_STUDENT_EXCLUDED_TEACHERS.has(String(row.teacherName || "").trim())).filter(row => !keyword || String(row[field] || "").toLowerCase().includes(keyword)).map(row => ({
        ...row
      })).sort((a, b) => Number(hasStudentName(b)) - Number(hasStudentName(a)) || String(a.studentName).localeCompare(String(b.studentName), "zh-CN") || studentKey(a).localeCompare(studentKey(b)) || a.date.localeCompare(b.date) || a.period.localeCompare(b.period) || Number(a.courseArrangeId) - Number(b.courseArrangeId));
      rows.forEach((row, index) => {
        row._rowIndex = index;
      });
      const markSpans = (key, field, onGroup) => {
        let start = 0;
        while (start < rows.length) {
          let end = start + 1;
          while (end < rows.length && key(rows[end]) === key(rows[start])) end += 1;
          rows[start][field] = end - start;
          for (let i = start + 1; i < end; i += 1) rows[i][field] = 0;
          const prefix = field === "_studentSpan" ? "_student" : "_primary";
          for (let i = start; i < end; i += 1) {
            rows[i][`${prefix}Start`] = start;
            rows[i][`${prefix}End`] = end;
          }
          if (onGroup) onGroup(rows.slice(start, end));
          start = end;
        }
      };
      markSpans(studentKey, "_studentSpan");
      markSpans(row => `${row.date}:${studentKey(row)}`, "_primarySpan", group => {
        group[0].primaryTotalHour = hasStudentName(group[0]) ? parseFloat((group.reduce((sum, row) => sum + (row.totalMinutes == null ? Number(row.hour) * 60 : Number(row.totalMinutes)), 0) / 60).toFixed(2)) : "-";
      });
      return rows;
    },
    desenSpanMethod({
      row,
      columnIndex
    }) {
      const prefix = columnIndex === 0 ? "_student" : columnIndex === 1 || columnIndex === 9 ? "_primary" : null;
      if (prefix) {
        const {
          start,
          end
        } = this.desenVirtualRange;
        const visibleStart = Math.max(start, row[`${prefix}Start`]);
        return row._rowIndex === visibleStart ? [Math.min(end, row[`${prefix}End`]) - visibleStart, 1] : [0, 0];
      }
      return [1, 1];
    },
    async saveDesenCheck(row, field, checked) {
      try {
        const response = await axios.post("https://backend.wonology.com/courseStatistics/setCourseCheckStatus", {
          institution: this.institution,
          courseArrangeId: row.courseArrangeId,
          studentId: row.studentId,
          field,
          checked
        });
        if (response.data.code !== "0000") throw new Error(response.data.msg);
        const sourceRow = this.desenRows.find(item => item.courseArrangeId == row.courseArrangeId && item.studentId == row.studentId);
        if (sourceRow) sourceRow[field] = checked;
      } catch (error) {
        row[field] = !checked;
        alert("保存勾选状态失败：" + (error.message || error));
      }
    },
    openDesenExport() {
      const today = moment().format("YYYY-MM-DD");
      this.exportDateRange = this.dateRange.length === 2 ? [...this.dateRange] : [today, today];
      this.exportTargetId = "";
      this.showDesenExportDialog = true;
    },
    async exportDesenStatistics() {
      if (!this.exportDateRange || this.exportDateRange.length !== 2) {
        alert("请选择导出日期范围");
        return;
      }
      this.exportingDesen = true;
      try {
        const response = await axios.post("https://backend.wonology.com/courseStatistics/getClassCourseTeacherHour", {
          institution: this.institution,
          dateRange: this.exportDateRange
        });
        if (response.data.code !== "0000") throw new Error(response.data.msg);
        const rows = this.prepareDesenStudentRows((response.data.data && response.data.data.desenRows || []).filter(row => !this.exportTargetId || String(row.studentId) === this.exportTargetId));
        if (rows.length === 0) {
          alert("所选日期范围内没有排课数据");
          return;
        }
        const exportData = [["学生", "日期", "班级名称", "老师姓名", "班级类型", "校区名称", "科目", "上课时段", "课时(小时)", "课时合计", "群内课程通知check", "课消check"]];
        rows.forEach(row => exportData.push([row.studentName, row.date, row.className, row.teacherName, row.classType, row.campusName, row.course, row.period, row.hour, row.primaryTotalHour ?? "", row.courseNotified ? "☑" : "☐", row.courseCleared ? "☑" : "☐"]));
        const ExcelJSModule = await import("exceljs/dist/exceljs.min.js");
        const ExcelJS = ExcelJSModule.default || ExcelJSModule;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("课时统计", {
          views: [{
            state: "frozen",
            ySplit: 1
          }]
        });
        exportData.forEach(item => worksheet.addRow(item));
        const mergeGroups = (column, keyBuilder) => {
          let start = 0;
          while (start < rows.length) {
            const key = keyBuilder(rows[start]);
            let end = start + 1;
            while (end < rows.length && keyBuilder(rows[end]) === key) end += 1;
            if (end - start > 1) {
              // 第 1 行是表头，ExcelJS 行列编号均从 1 开始。
              worksheet.mergeCells(start + 2, column, end + 1, column);
            }
            start = end;
          }
        };
        mergeGroups(1, row => String(row.studentId || `empty-${row.classId}`));
        [2, 10].forEach(column => mergeGroups(column, row => `${row.date}:${row.studentId || `empty-${row.classId}`}`));
        worksheet.columns = [{
          width: 16
        }, {
          width: 13
        }, {
          width: 36
        }, {
          width: 16
        }, {
          width: 12
        }, {
          width: 16
        }, {
          width: 18
        }, {
          width: 16
        }, {
          width: 14
        }, {
          width: 14
        }, {
          width: 30
        }, {
          width: 14
        }];
        worksheet.getRow(1).height = 30;
        worksheet.getRow(1).font = {
          bold: true,
          size: 12
        };
        worksheet.getRow(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FFEAF2F8"
          }
        };
        worksheet.eachRow((excelRow, rowNumber) => {
          if (rowNumber > 1) excelRow.height = 24;
          excelRow.eachCell(cell => {
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true
            };
            cell.border = {
              top: {
                style: "thin",
                color: {
                  argb: "FF808080"
                }
              },
              left: {
                style: "thin",
                color: {
                  argb: "FF808080"
                }
              },
              bottom: {
                style: "thin",
                color: {
                  argb: "FF808080"
                }
              },
              right: {
                style: "thin",
                color: {
                  argb: "FF808080"
                }
              }
            };
          });
        });
        for (let rowNumber = 2; rowNumber <= rows.length + 1; rowNumber += 1) {
          [11, 12].forEach(column => {
            const cell = worksheet.getCell(rowNumber, column);
            cell.dataValidation = {
              type: "list",
              allowBlank: false,
              formulae: ['"☐,☑"'],
              showErrorMessage: true,
              errorTitle: "请选择勾选状态",
              error: "只能选择 ☐ 或 ☑",
              showInputMessage: true,
              promptTitle: "勾选状态",
              prompt: "点击单元格右侧下拉箭头切换 ☐/☑"
            };
            cell.font = {
              size: 16
            };
          });
        }
        const fileName = `得森学生课时统计_${this.exportDateRange[0]}-${this.exportDateRange[1]}.xlsx`;
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const downloadUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        URL.revokeObjectURL(downloadUrl);
        this.showDesenExportDialog = false;
      } catch (error) {
        alert("导出失败：" + (error.message || error));
      } finally {
        this.exportingDesen = false;
      }
    },
    search() {
      if (this.institution == "得森" && this.showStatisticsType == "student") {
        this.desenStudentSearchStr = this.searchStr;
        return;
      }
      // 班级统计
      if (this.showStatisticsType == "class") {
        this.classCourseTeacherHour = {};
        this.classCourseTeacherArr = {};
        this.totalHour = 0;
        this.showSearchResult = true;

        // if (this.searchStr == "") {
        //   return;
        // }

        for (let classId in this.oriClassCourseTeacherHour) {
          // 如果班级名包含搜索内容
          if (this.classNames[classId].toLowerCase().includes(this.searchStr.toLowerCase())) {
            this.classCourseTeacherHour[classId] = this.oriClassCourseTeacherHour[classId];
            this.classCourseTeacherArr[classId] = this.oriClassCourseTeacherArr[classId];
          }
        }

        // 计算课时合计
        for (let classId in this.classCourseTeacherHour) {
          for (let course in this.classCourseTeacherHour[classId]) {
            for (let teacherId in this.classCourseTeacherHour[classId][course]) {
              this.totalHour = this.totalHour + this.classCourseTeacherHour[classId][course][teacherId].hour;
            }
          }
        }
      }
      // 老师统计
      if (this.showStatisticsType == "teacher") {
        this.teacherClassCourseHour = {};
        this.teacherClassCourseArr = {};
        this.totalHour = 0;

        // if (this.searchStr == "") {
        //   return;
        // }

        for (let teacherId in this.oriTeacherClassCourseHour) {
          // 如果老师名包含搜索内容
          if (this.teacherNames[teacherId].toLowerCase().includes(this.searchStr.toLowerCase())) {
            this.teacherClassCourseHour[teacherId] = this.oriTeacherClassCourseHour[teacherId];
            this.teacherClassCourseArr[teacherId] = this.oriTeacherClassCourseArr[teacherId];
          }
        }

        // 统计课时
        for (let teacherId in this.teacherClassCourseHour) {
          for (let classId in this.teacherClassCourseHour[teacherId]) {
            for (let course in this.teacherClassCourseHour[teacherId][classId]) {
              this.totalHour = this.totalHour + this.teacherClassCourseHour[teacherId][classId][course].hour;
            }
          }
        }
        this.showSearchResult = true;
      }
    },
    cancelSearch() {
      this.searchStr = "";

      // 恢复原始数据
      if (this.showStatisticsType == "class") {
        this.classCourseTeacherHour = this.oriClassCourseTeacherHour;
        this.classCourseTeacherArr = this.oriClassCourseTeacherArr;
      }
      if (this.showStatisticsType == "teacher") {
        this.teacherClassCourseHour = this.oriTeacherClassCourseHour;
        this.teacherClassCourseArr = this.oriTeacherClassCourseArr;
      }
      this.showSearchResult = false;
    },
    // 班级，老师 切换
    async classTeacherSwitch(type) {
      if (this.showStatisticsType === type) return;
      if (this.institution === "得森" && this.statisticsBusy) return;
      const showLoading = this.institution === "得森";
      if (showLoading) {
        this.hideDesenCellTooltip();
        this.statisticsLoadingText = "正在切换课时统计...";
        this.statisticsBusy = true;
      }
      try {
        if (!showLoading) this.cancelSearch();
        // 页签选择与表格显隐分开：本轮只更新页签和转圈，保持旧表格布局。
        this.showStatisticsType = type;
        if (type == "class") {
          this.searchPlaceholder = "搜索班级";
        } else if (type == "teacher") {
          this.searchPlaceholder = "搜索老师";
        } else if (type == "student") {
          this.searchPlaceholder = showLoading ? `搜索${this.desenStudentSearchLabel}` : "搜索学生";
        }
        if (showLoading) {
          await this.waitForStatisticsPaint();
          // 转圈已完成绘制，再清空筛选、改变表格布局及创建首次访问的视图。
          this.cancelSearch();
          this.displayedStatisticsType = type;
          // 访问过的视图保留DOM，往返切换不再销毁、重建学生明细表。
          this.desenMountedViews[type] = true;
        }
        this.search();
      } finally {
        if (showLoading) {
          try {
            await this.waitForStatisticsReady();
          } finally {
            this.statisticsBusy = false;
          }
        }
      }
    },
    // 导出课时统计excel 选择导出每节课详细还是不详细
    downloadStatistics() {
      this.showDownloadConfirm = true;
    },
    downloadStatisticsConfirm() {
      if (this.downloadDetail) {
        this.downloadStatistics_withDetail();
      } else {
        this.downloadStatistics_withoutDetail();
      }
    },
    downloadStatisticsCancel() {
      this.showDownloadConfirm = false;
    },
    // 导出课时统计excel （包含每节课的详情）
    downloadStatistics_withDetail() {
      // 班级课时统计
      if (this.showStatisticsType == "class") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["班级名称", "班级类型", "校区名称", "科目", "老师姓名", "上课日期", "上课时间", "老师课时合计(小时)", "班级课时合计(小时)"]);
          let currentClassId = null;
          let classRowStart = 1; // 第一行是表头，所以数据从第2行开始

          for (let classId in this.classCourseTeacherHour) {
            const classItem = this.classCourseTeacherHour[classId];

            // 如果是第一个条目，或者班级ID变了，则记录起始行
            if (currentClassId !== classId) {
              currentClassId = classId;
              classRowStart = exportData.length; // 记录当前班级的第一行行数
            }
            let currentCourseId = null;
            let courseRowStart = 1;

            // 遍历该班级的所有课程和老师
            for (let course in classItem) {
              // 如果是第一个条目，或者科目 变了，则记录起始行
              if (currentCourseId !== course) {
                currentCourseId = course;
                courseRowStart = exportData.length;
              }
              let currentTeacherId = null;
              let teacherRowStart = 1;
              for (let teacherId in classItem[course]) {
                const item = classItem[course][teacherId];

                // 如果是第一个条目，或者老师 ID 变了，则记录起始行
                if (currentTeacherId !== teacherId) {
                  currentTeacherId = teacherId;
                  teacherRowStart = exportData.length;
                }
                let classCourseTeacherArr = this.classCourseTeacherArr[classId][course][teacherId];
                for (let i in classCourseTeacherArr) {
                  const courseItem = classCourseTeacherArr[i];

                  // 添加数据行
                  exportData.push([item.className,
                  // 班级名（后续会被合并）
                  item.classType, item.campusName, item.course, item.teacherName, courseItem.date, courseItem.period, item.hour, this.classHours[classId]]);
                }

                // 计算当前老师的数据行数
                const teacherRowCount = exportData.length - teacherRowStart;

                // 合并 老师姓名（E列）
                mergeCells.push(`E${teacherRowStart + 1}:E${teacherRowStart + teacherRowCount}`);
                // 合并 老师课时合计（H列）
                mergeCells.push(`H${teacherRowStart + 1}:H${teacherRowStart + teacherRowCount}`);
              }

              // 计算当前科目的数据行数
              const courseRowCount = exportData.length - courseRowStart;

              // 合并 科目（D列）
              mergeCells.push(`D${courseRowStart + 1}:D${courseRowStart + courseRowCount}`);
            }

            // 计算当前班级的数据行数
            const rowCount = exportData.length - classRowStart;

            // 合并 班级名称（A列）
            mergeCells.push(`A${classRowStart + 1}:A${classRowStart + rowCount}`);
            // 合并 班级类型（B列）
            mergeCells.push(`B${classRowStart + 1}:B${classRowStart + rowCount}`);
            // 合并 校区名称（C列）
            mergeCells.push(`C${classRowStart + 1}:C${classRowStart + rowCount}`);
            // 合并 合计课时（I列）
            mergeCells.push(`I${classRowStart + 1}:I${classRowStart + rowCount}`);
          }

          // console.log("mergeCells:", mergeCells);

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          // 将之前收集的所有合并区域（如 "A2:A4", "B2:B4" 等）转换成 xlsx 库能识别的格式
          ws["!merges"] = mergeCells.map(range => {
            // 示例：range = "A2:A4"
            const [start, end] = range.split(":"); // 分割成 ["A2", "A4"]

            // 安全解析起始单元格
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) {
              console.warn("Invalid start cell:", start);
              return; // 跳过无效项
            }

            // 解析起始单元格（如 A2）
            const [startRow, startCol] = start.match(/([A-Z]+)(\d+)/) // 匹配数字和字母部分，比如 "2" 和 "A"
            .slice(1) // 取匹配到的两个组：["2", "A"]
            .reverse(); // 反转顺序，变成 ["A", "2"] → 方便后续处理

            // 解析结束单元格（如 A4）
            const [endRow, endCol] = end.match(/([A-Z]+)(\d+)/).slice(1).reverse();

            // 返回一个对象，表示合并区域的起始和结束坐标
            return {
              s: {
                // s 表示 start（起始）
                r: parseInt(startRow) - 1,
                // 行号从0开始，所以减1（Excel 第2行对应索引1）
                c: startCol.charCodeAt(0) - 65 // 列号转换：'A'=65 → 0, 'B'=66 → 1
              },
              e: {
                // e 表示 end（结束）
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽 (单位：字符数)
          ws["!cols"] = [{
            wch: 40
          },
          // A列 班级名称
          {
            wch: 15
          },
          // B列 班级类型
          {
            wch: 15
          },
          // C列 校区名称
          {
            wch: 15
          },
          // D列 科目
          {
            wch: 15
          },
          // E列 老师姓名
          {
            wch: 12
          },
          // F列 课时 (小时)
          {
            wch: 12
          } // G列 课时合计
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;

              // 设置单元格样式
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  // 垂直居中
                  horizontal: "center",
                  // 水平居中
                  wrapText: true // 自动换行
                },
                font: {
                  sz: 12,
                  // 字体大小
                  bold: R === 0 // 表头加粗
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            }; // 行高 25 像素
          }

          // 创建工作簿
          const wb = XLSX.utils.book_new();
          // 添加工作表
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `班级课时统计_含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          // 导出
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败: " + error.message);
        }
      }
      // 老师课时统计
      if (this.showStatisticsType == "teacher") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["老师姓名", "班级名称", "班级类型", "校区名称", "科目", "上课日期", "上课时间", "科目课时合计 (小时)", "老师课时合计 (小时)"]);
          let currentTeacherId = null;
          let teacherRowStart = 1;
          for (let teacherId in this.teacherClassCourseHour) {
            const teacherItem = this.teacherClassCourseHour[teacherId];

            // 如果是第一个条目，或者老师 ID 变了，则记录起始行
            if (currentTeacherId !== teacherId) {
              currentTeacherId = teacherId;
              teacherRowStart = exportData.length;
            }
            let currentClassId = null;
            let classRowStart = 1;

            // 遍历该老师的所有班级和科目
            for (let classId in teacherItem) {
              // 如果是第一个条目，或者班级 ID 变了，则记录起始行
              if (currentClassId !== classId) {
                currentClassId = classId;
                classRowStart = exportData.length;
              }
              let currentCourse = null;
              let courseRowStart = 1;
              for (let course in teacherItem[classId]) {
                // 如果是第一个条目，或者科目变了，则记录起始行
                if (currentCourse !== course) {
                  currentCourse = course;
                  courseRowStart = exportData.length;
                }
                let item = teacherItem[classId][course];
                let courseArr = this.teacherClassCourseArr[teacherId][classId][course];

                // 科目的每节课
                for (let i in courseArr) {
                  const courseItem = courseArr[i];

                  // 添加数据行
                  exportData.push([item.teacherName,
                  // 老师姓名（后续会被合并）
                  item.className, item.classType, item.campusName, item.course, courseItem.date, courseItem.period, item.hour, this.teacherHours[teacherId] // 课时合计（后续会被合并）
                  ]);
                }

                // 计算当前科目的数据行数
                const courseRowCount = exportData.length - courseRowStart;

                // 合并 科目（E 列）
                mergeCells.push(`E${courseRowStart + 1}:E${courseRowStart + courseRowCount}`);

                // 合并 科目课时合计（H 列）
                mergeCells.push(`H${courseRowStart + 1}:H${courseRowStart + courseRowCount}`);
              }

              // 计算当前班级的数据行数
              const classRowCount = exportData.length - classRowStart;

              // 合并 班级名称（B 列）
              mergeCells.push(`B${classRowStart + 1}:B${classRowStart + classRowCount}`);
              // 合并 班级类型（C 列）
              mergeCells.push(`C${classRowStart + 1}:C${classRowStart + classRowCount}`);
              // 合并 校区名称（D 列）
              mergeCells.push(`D${classRowStart + 1}:D${classRowStart + classRowCount}`);
            }

            // 计算当前老师的数据行数
            const teacherRowCount = exportData.length - teacherRowStart;

            // 合并 老师姓名（A 列）
            mergeCells.push(`A${teacherRowStart + 1}:A${teacherRowStart + teacherRowCount}`);
            // 合并 课时合计（I 列）
            mergeCells.push(`I${teacherRowStart + 1}:I${teacherRowStart + teacherRowCount}`);
          }

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          ws["!merges"] = mergeCells.map(range => {
            const [start, end] = range.split(":");
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) return;
            const [, startCol, startRow] = start.match(/([A-Z]+)(\d+)/);
            const [, endCol, endRow] = end.match(/([A-Z]+)(\d+)/);
            return {
              s: {
                r: parseInt(startRow) - 1,
                c: startCol.charCodeAt(0) - 65
              },
              e: {
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽
          ws["!cols"] = [{
            wch: 15
          },
          // A 列 老师姓名
          {
            wch: 40
          },
          // B 列 班级名称
          {
            wch: 15
          },
          // C 列 班级类型
          {
            wch: 15
          },
          // D 列 校区名称
          {
            wch: 15
          },
          // E 列 科目
          {
            wch: 15
          },
          // F 列 上课日期
          {
            wch: 15
          },
          // G 列 上课时间
          {
            wch: 12
          },
          // H 列 科目课时合计 (小时)
          {
            wch: 12
          } // I 列 老师课时合计 (小时)
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  horizontal: "center",
                  wrapText: true
                },
                font: {
                  sz: 12,
                  bold: R === 0
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            };
          }
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `老师课时统计_含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败：" + error.message);
        }
      }
    },
    // 导出课时统计excel （不包含每节课的详情）
    downloadStatistics_withoutDetail() {
      // 班级课时统计
      if (this.showStatisticsType == "class") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["班级名称", "班级类型", "校区名称", "科目", "老师姓名", "老师课时合计(小时)", "班级课时合计(小时)"]);
          let currentClassId = null;
          let rowStart = 1; // 第一行是表头，所以数据从第2行开始

          for (let classId in this.classCourseTeacherHour) {
            const classItem = this.classCourseTeacherHour[classId];

            // 如果是第一个条目，或者班级ID变了，则记录起始行
            if (currentClassId !== classId) {
              currentClassId = classId;
              rowStart = exportData.length; // 记录当前班级的第一行行数
            }
            let currentCourseId = null;
            let courseRowStart = 1;

            // 遍历该班级的所有课程和老师
            for (let course in classItem) {
              // 如果是第一个条目，或者科目变了，则记录起始行
              if (currentCourseId !== course) {
                currentCourseId = course;
                courseRowStart = exportData.length;
              }
              for (let teacherId in classItem[course]) {
                const item = classItem[course][teacherId];

                // 添加数据行
                exportData.push([item.className,
                // 班级名（后续会被合并）
                item.classType, item.campusName, item.course, item.teacherName, item.hour, this.classHours[classId]]);
              }

              // 计算当前科目的数据行数
              const courseRowCount = exportData.length - courseRowStart;

              // 合并 科目（D列）
              mergeCells.push(`D${courseRowStart + 1}:D${courseRowStart + courseRowCount}`);
            }

            // 计算当前班级的数据行数
            const rowCount = exportData.length - rowStart;

            // 合并 班级名称（A列）
            mergeCells.push(`A${rowStart + 1}:A${rowStart + rowCount}`);
            // 合并 班级类型（B列）
            mergeCells.push(`B${rowStart + 1}:B${rowStart + rowCount}`);
            // 合并 校区名称（C列）
            mergeCells.push(`C${rowStart + 1}:C${rowStart + rowCount}`);
            // 合并 合计课时（G列）
            mergeCells.push(`G${rowStart + 1}:G${rowStart + rowCount}`);
          }

          // console.log("mergeCells:", mergeCells);

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          // 将之前收集的所有合并区域（如 "A2:A4", "B2:B4" 等）转换成 xlsx 库能识别的格式
          ws["!merges"] = mergeCells.map(range => {
            // 示例：range = "A2:A4"
            const [start, end] = range.split(":"); // 分割成 ["A2", "A4"]

            // 安全解析起始单元格
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) {
              console.warn("Invalid start cell:", start);
              return; // 跳过无效项
            }

            // 解析起始单元格（如 A2）
            const [startRow, startCol] = start.match(/([A-Z]+)(\d+)/) // 匹配数字和字母部分，比如 "2" 和 "A"
            .slice(1) // 取匹配到的两个组：["2", "A"]
            .reverse(); // 反转顺序，变成 ["A", "2"] → 方便后续处理

            // 解析结束单元格（如 A4）
            const [endRow, endCol] = end.match(/([A-Z]+)(\d+)/).slice(1).reverse();

            // 返回一个对象，表示合并区域的起始和结束坐标
            return {
              s: {
                // s 表示 start（起始）
                r: parseInt(startRow) - 1,
                // 行号从0开始，所以减1（Excel 第2行对应索引1）
                c: startCol.charCodeAt(0) - 65 // 列号转换：'A'=65 → 0, 'B'=66 → 1
              },
              e: {
                // e 表示 end（结束）
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽 (单位：字符数)
          ws["!cols"] = [{
            wch: 40
          },
          // A列 班级名称
          {
            wch: 15
          },
          // B列 班级类型
          {
            wch: 15
          },
          // C列 校区名称
          {
            wch: 15
          },
          // D列 科目
          {
            wch: 15
          },
          // E列 老师姓名
          {
            wch: 12
          },
          // F列 课时 (小时)
          {
            wch: 12
          } // G列 课时合计
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;

              // 设置单元格样式
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  // 垂直居中
                  horizontal: "center",
                  // 水平居中
                  wrapText: true // 自动换行
                },
                font: {
                  sz: 12,
                  // 字体大小
                  bold: R === 0 // 表头加粗
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            }; // 行高 25 像素
          }

          // 创建工作簿
          const wb = XLSX.utils.book_new();
          // 添加工作表
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `班级课时统计_不含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          // 导出
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败: " + error.message);
        }
      }
      // 老师课时统计
      if (this.showStatisticsType == "teacher") {
        try {
          const exportData = [];
          const mergeCells = [];

          // 添加表头
          exportData.push(["老师姓名", "班级名称", "班级类型", "校区名称", "科目", "科目课时合计 (小时)", "老师课时合计 (小时)"]);
          let currentTeacherId = null;
          let teacherRowStart = 1;
          for (let teacherId in this.teacherClassCourseHour) {
            const teacherItem = this.teacherClassCourseHour[teacherId];

            // 如果是第一个条目，或者老师 ID 变了，则记录起始行
            if (currentTeacherId !== teacherId) {
              currentTeacherId = teacherId;
              teacherRowStart = exportData.length;
            }

            // 遍历该老师的所有班级和课程
            for (let classId in teacherItem) {
              let currentClassId = null;
              let classRowStart = 1;

              // 如果是第一个条目，或者班级 ID 变了，则记录起始行
              if (currentClassId !== classId) {
                currentClassId = classId;
                classRowStart = exportData.length;
              }
              for (let course in teacherItem[classId]) {
                const item = teacherItem[classId][course];

                // 添加数据行
                exportData.push([item.teacherName,
                // 老师姓名（后续会被合并）
                item.className, item.classType, item.campusName, item.course, item.hour, this.teacherHours[teacherId] // 课时合计（后续会被合并）
                ]);
              }

              // 计算当前班级的数据行数
              const classRowCount = exportData.length - classRowStart;

              // 合并 班级名称（B 列）
              mergeCells.push(`B${classRowStart + 1}:B${classRowStart + classRowCount}`);
              // 合并 班级类型（C 列）
              mergeCells.push(`C${classRowStart + 1}:C${classRowStart + classRowCount}`);
              // 合并 校区名称（D 列）
              mergeCells.push(`D${classRowStart + 1}:D${classRowStart + classRowCount}`);
            }

            // 计算当前老师的数据行数
            const rowCount = exportData.length - teacherRowStart;

            // 合并 老师姓名（A 列）
            mergeCells.push(`A${teacherRowStart + 1}:A${teacherRowStart + rowCount}`);
            // 合并 课时合计（G 列）
            mergeCells.push(`G${teacherRowStart + 1}:G${teacherRowStart + rowCount}`);
          }

          // 创建工作簿
          const ws = XLSX.utils.aoa_to_sheet(exportData);

          // 设置合并单元格
          ws["!merges"] = mergeCells.map(range => {
            const [start, end] = range.split(":");
            const startMatch = start.match(/([A-Z]+)(\d+)/);
            if (!startMatch) return;
            const [, startCol, startRow] = start.match(/([A-Z]+)(\d+)/);
            const [, endCol, endRow] = end.match(/([A-Z]+)(\d+)/);
            return {
              s: {
                r: parseInt(startRow) - 1,
                c: startCol.charCodeAt(0) - 65
              },
              e: {
                r: parseInt(endRow) - 1,
                c: endCol.charCodeAt(0) - 65
              }
            };
          });

          // 设置列宽
          ws["!cols"] = [{
            wch: 15
          },
          // A 列 老师姓名
          {
            wch: 40
          },
          // B 列 班级名称
          {
            wch: 15
          },
          // C 列 班级类型
          {
            wch: 15
          },
          // D 列 校区名称
          {
            wch: 15
          },
          // E 列 科目
          {
            wch: 12
          },
          // F 列 科目课时合计 (小时)
          {
            wch: 12
          } // G 列 老师课时合计 (小时)
          ];

          // 设置单元格样式 - 垂直水平居中
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C
              });
              if (!ws[cellAddress]) continue;
              ws[cellAddress].s = {
                alignment: {
                  vertical: "center",
                  horizontal: "center",
                  wrapText: true
                },
                font: {
                  sz: 12,
                  bold: R === 0
                },
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              };
            }
          }

          // 设置行高
          ws["!rows"] = [];
          for (let R = range.s.r; R <= range.e.r; ++R) {
            ws["!rows"][R] = {
              hpt: 25
            };
          }
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "sheet1");
          const fileName = `老师课时统计_不含每节课详情_${this.dateRange[0]}-${this.dateRange[1]}.xlsx`;
          XLSX.writeFile(wb, fileName);
          console.log("导出成功");
        } catch (error) {
          console.error("导出失败:", error);
          alert("导出失败：" + error.message);
        }
      }
    }
  }
};